import React from "react";
import {
  IonContent,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  useIonModal,
} from "@ionic/react";
import { useIntl } from "react-intl";
import Logo from "../../components/Logo";
import SettingsList from "./components/SettingsList";
import Signature from "./components/Signature";
import TextSizer from "./components/TextSizer";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateSignature, loadRecord } from "../employee/employeeSlice";

const Settings = (props) => {
  const { routerRef } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.auth);

  const handleDismiss = () => {
    dismiss();
  };

  const handleDismissTextSizer = () => {
    dismissTextSizer();
  };
  const onChangeSignature = async (data) => {
    await dispatch(updateSignature({ signature: data }));
    const params = {
      id: profile.associated_employee_id,
    };
    dispatch(loadRecord(params));
  };

  const onChangeTextSize = (size) => {
    localStorage.setItem("textSize", +size);
    window.dispatchEvent(new Event("storage"));
  };

  const [present, dismiss] = useIonModal(
    <Signature
      parentRef={routerRef}
      hideModal={handleDismiss}
      onChangeSignature={onChangeSignature}
    />,
    {
      onDismiss: handleDismiss,
    }
  );

  const [presentTextSizer, dismissTextSizer] = useIonModal(
    <TextSizer
      hideModal={handleDismissTextSizer}
      onChangeTextSize={onChangeTextSize}
    />,
    {
      onDismiss: handleDismissTextSizer,
    }
  );

  return (
    <IonPage>
      <IonToolbar color="primary">
        <IonButtons slot="primary">
          <Logo />
        </IonButtons>
        <IonTitle>
          {intl.formatMessage({
            id: "app.mobile.titles.settings",
          })}
        </IonTitle>
      </IonToolbar>
      <IonContent>
        <SettingsList
          // onShowSignatureModal={onShowSignatureModal}
          signaturePresent={present}
          presentTextSizer={presentTextSizer}
        />
      </IonContent>
    </IonPage>
  );
};

export default Settings;
